import { designTokens as dt, styled } from '@project44/manifest-ds';
import { Spinner } from '@project44/manifest-ui-deprecated';

const Page = styled('div', {
  alignItems: 'center',
  backgroundColor: `${dt.colorPaletteGrey100}`,
  display: 'flex',
  height: '100vh',
  justifyContent: 'center',
  position: 'absolute',
  top: 0,
  width: '100vw',
});

const Loader = () => {
  return (
    <Page data-testid="loader">
      <Spinner data-testid="spinner" />
    </Page>
  );
};

export default Loader;
